import ApiService from '../api.service'
import getCurrentCompanyId from '../company.service'

const basePath = () => `/v1/companies/${getCurrentCompanyId()}/notification_groups`

const NotificationGroupResource = {
  list: (params?: { active?: boolean; items?: number }) => {
    const search = params ? new URLSearchParams(params as any).toString() : ''
    return ApiService.get(`${basePath()}${search ? `?${search}` : ''}`)
  },
  show: (id: number) => ApiService.get(`${basePath()}/${id}`),
  create: (data: { name: string; description?: string; active?: boolean; user_ids?: number[]; group_ids?: number[]; alarm_types?: string[] }) =>
    ApiService.post(basePath(), { notification_group: { name: data.name, description: data.description, active: data.active }, user_ids: data.user_ids, group_ids: data.group_ids, alarm_types: data.alarm_types }),
  update: (id: number, data: { name?: string; description?: string; active?: boolean }) =>
    ApiService.put(`${basePath()}/${id}`, { notification_group: data }),
  destroy: (id: number) => ApiService.delete(`${basePath()}/${id}`),
  addUsers: (id: number, userIds: number[]) =>
    ApiService.post(`${basePath()}/${id}/add_users`, { user_ids: userIds }),
  removeUsers: (id: number, userIds: number[]) =>
    ApiService.delete(`${basePath()}/${id}/remove_users`, { user_ids: userIds }),
  addGroups: (id: number, groupIds: number[]) =>
    ApiService.post(`${basePath()}/${id}/add_groups`, { group_ids: groupIds }),
  removeGroups: (id: number, groupIds: number[]) =>
    ApiService.delete(`${basePath()}/${id}/remove_groups`, { group_ids: groupIds }),
  addAlarmTypes: (id: number, alarmTypes: string[]) =>
    ApiService.post(`${basePath()}/${id}/add_alarm_types`, { alarm_types: alarmTypes }),
  removeAlarmTypes: (id: number, alarmTypes: string[]) =>
    ApiService.delete(`${basePath()}/${id}/remove_alarm_types`, { alarm_types: alarmTypes }),
}

export default NotificationGroupResource
